module.exports = __webpack_public_path__ + "img/slidebar-bg.6a495b51.png";